export default __webpack_public_path__ + "static/media/mainBg.cdc3c982.jpg";